<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatter">
<div class="illustype_image_text"><div class="image_text" style="width:75%"><img alt="e9781439611975_i0002.jpg" src="images/e9781439611975_i0002.jpg"/></div>
<div class="caption"><p class="p"><span>A new map of New Hampshire by Jeremy Belknap, 1791.</span></p></div></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781439611975_fm01.vue?96e8a498